import React from 'react';
import * as Types from 'pages/Pages/typings';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import pluralize from 'pluralize';
import { BASE_FIELD_PAGE, BASE_FIELD_PAGE_COLLECTION } from 'pages/Attributes/consts';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import AttributeTypeCard, { attributeTypes } from 'pages/AttributesNew/AttributeTypeCard';

import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  entityType: Types.EntityType;
  values: Types.EntitySettingsFormValues;
  onChange: (field: string, value: any) => void;
}

function PageTypeName({ entityType, values, onChange }: Props) {
  const classes = useStyles();
  let pageItem = _get(attributeTypes, BASE_FIELD_PAGE);
  let pageCollectionItem = _get(attributeTypes, BASE_FIELD_PAGE_COLLECTION);
  let independentItem = _get(attributeTypes, 'independentPage');
  const personClientFieldObjectKey = _get(entityType, '_personClientFieldObjectKey');
  const isIndependentPage = _isNil(_get(entityType, 'personClientFieldId', null));

  const item = isIndependentPage
    ? independentItem
    : personClientFieldObjectKey && personClientFieldObjectKey.includes('cf_pageCollection')
    ? pageCollectionItem
    : personClientFieldObjectKey && personClientFieldObjectKey.includes('cf_page')
    ? pageItem
    : null;

  const handleChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange('name', e.target.value);
  };

  const handleChangeDescription = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 0) {
      onChange('description', e.target.value);
    } else {
      onChange('description', null);
    }
  };

  return (
    <div className={classes.root}>
      <Card className={classes.cardRoot}>
        <CardContent>
          <div className={classes.marginBottom}>
            <Typography variant="h6">Page Type Title</Typography>
            <Typography variant="subtitle2">
              What type of thing do these pages represent? For example: "Project", "Award", etc.
            </Typography>
            <TextField
              id="page-type-attribute-name"
              error={values.name === ''}
              fullWidth
              helperText={values.name === '' && 'Name is a required field'}
              value={values.name}
              onChange={handleChangeName}
              inputProps={{ 'aria-label': 'page type attribute name' }}
            />
            <Typography variant="subtitle2">
              {values.name && `Plural form: ${pluralize(values.name, 2)}. It will show up when...`}
            </Typography>
          </div>
          <div>
            <Typography variant="h6">Description</Typography>
            <Typography variant="subtitle2">
              This description will be shown when a user edits the attribute on their profile page.
              (if applicable)
            </Typography>
            <TextField
              id="page-type-description"
              fullWidth
              value={_get(values, 'description') || ''}
              onChange={handleChangeDescription}
              inputProps={{ 'aria-label': 'page type description' }}
            />
          </div>
        </CardContent>
      </Card>
      {item && <AttributeTypeCard item={item} link={false} />}
    </div>
  );
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginTop: theme.spacing(3),
  },
  cardRoot: {
    marginRight: theme.spacing(3),
    flexGrow: 1,
  },
  marginBottom: {
    marginBottom: theme.spacing(3),
  },
}));

export default PageTypeName;
